import React from 'react';

const Tech = () => {
  return (
    <div style={{
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #cffafe 0%, #dbeafe 100%)',
      padding: '2rem 1rem',
    }}>
      <div className="page-wrapper">
        <div className="page-hero">
          <h1>💻 Technology</h1>
          <p>Discover the latest technology trends and insights.</p>
        </div>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '2rem',
        }}>
          <p>Tech content will be rendered here</p>
        </div>
      </div>
    </div>
  );
};

export default Tech;
